export const RolesValues = ["Admin", "Expert", "User", "Readonly"] as const;

export type Roles = (typeof RolesValues)[number];

// A read-only user sees what an admin sees — but the users list — and changes nothing: every button
// that writes is hidden from it (the backend refuses it the same calls anyway).
export const seesAdminData = (role: Roles) =>
  role === "Admin" || role === "Readonly";
export const isReadonly = (role: Roles) => role === "Readonly";
// The grading analysis is in soft launch, for developers, and reads the color spreads only an admin
// or a read-only user may see. Its route in the menu configuration has the same roles.
export const seesGrading = (role: Roles, isDeveloper: boolean) =>
  isDeveloper && seesAdminData(role);

export interface AuthQuery {
  username: string;
  password: string;
  oldPassword?: string;
}

export interface AuthReply {
  token: string | null;
  isLogged: boolean;
  displayName: string | null;
  role: Roles;
  mainRole: Roles;
  isDeveloper: boolean;
}
